import { prepareCommonShaftData, sendShaft } from "./sendShaftCommon";
import { type LinearConfiguration } from "../../Linear/models";
import { prepareApiDataForResetNew, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";
import { type LinearConfiguratorState } from "../../Linear/redux/types";

export function sendShaftDataReset(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonShaftData(linearState);
  const resetData = prepareApiDataForResetNew(linearState);

  prepareGroupIdToDisplay(data);

  return sendShaft({
    ...data,
    ...resetData,
  });
}
